<template>
  <div class="content-wrapper">
    <div class="container-fluid" id="ul-saitemap">
      <preLoader v-if="loader"></preLoader>
      <br/>


    </div>
    <!--<section class="content-header">-->
    <!---->
    <!--<h1>-->
    <!--رسید-->
    <!--<small>#{{order.user_id}}{{order.id}}</small>-->
    <!--</h1>-->
    <!--<ol class="breadcrumb">-->
    <!--<li><a href="javascript: void(0)"><i class="fa fa-dashboard"></i> پنل مدیریت</a></li>-->
    <!--<li class="active">Beauty+</li>-->
    <!--</ol>-->
    <!--</section>-->


    <div class="row">

      <div class="col-lg-12 col-md-12 col-sm-12">

        <!-- Main content -->
        <section class="invoice p-5" id="printDiv" style="background-color: white">

          <order-invoice :order="order" :edit="true"></order-invoice>



          <!-- Modal -->
          <div id="editOrder" class="modal fade" role="dialog">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                  <h4 class="modal-title"> ویرایش اطلاعات سند</h4>
                </div>

                <div class="modal-body">
                  <div style="margin:5px">


                    <div class="form-group mt-2">
                      <label>
                        {{ $client }}/{{ $sale }}نده
                      </label>

                      <div>
                        <v-select
                            v-model="order.user_id"
                            :options="contacts" label="last_name" :reduce="contact => contact.user_id" value="user_id">
                        </v-select>
                      </div>
                    </div>


                    <div class="form-group">
                      <label>
                        تاریخ پیش فاکتور/فاکتور
                      </label>
                      <div class="">
                        <custom-time-picker v-model="order.general_date" :clearable="true"
                                            placeholder="تاریخ را انتخاب کنید"
                                            format="jYYYY/jMM/jDD" min="" max="">
                        </custom-time-picker>
                      </div>
                    </div>


                    <div class=" form-group">
                      <label class="control-label">نوع سند
                      </label>
                      <b-form-select v-model="order.factor_type">
                        <b-form-select-option value="-1">
                          رسید خرید
                        </b-form-select-option>
                        <b-form-select-option value="2">
                          حواله تولید
                        </b-form-select-option>
                        <b-form-select-option value="-2">
                          رسید تولید
                        </b-form-select-option>
                        <b-form-select-option value="1">
                          حواله/فاکتور {{ $sale }}
                        </b-form-select-option>
                        <b-form-select-option value="3">
                          صورت وضعیت
                        </b-form-select-option>
                      </b-form-select>

                    </div>


                    <div v-if="order.factor_type == 1" class=" form-group">
                      <label class="control-label">وضعیت فاکتور
                        <!--                                        {{ $t('Status description') }}:-->
                      </label>
                      <!--                                    <input type="text" v-model="order.description" :placeholder="$t('Description')" class="form-control">-->
                      <b-form-select v-model="order.factor_state">
                        <b-form-select-option value="1">
                          پیش فاکتور
                        </b-form-select-option>
                        <b-form-select-option value="2">
                          فاکتور
                        </b-form-select-option>
                      </b-form-select>
                    </div>


<!--                    <div class=" form-group">-->
<!--                      <label class="control-label">پروژه-->
<!--                      </label>-->
<!--                      <b-form-select v-model="order.project_id">-->
<!--                        <b-form-select-option v-for="(project, projectIndex) in projects" :key="projectIndex"-->
<!--                                              :value="project.id">-->
<!--                          {{ project.title }}-->
<!--                        </b-form-select-option>-->
<!--                      </b-form-select>-->
<!--                    </div>-->


                    <div class=" form-group">
                      <label class="control-label"> شماره فاکتور
                      </label>
                      <input type="number" v-model="order.code" placeholder="کد " class="form-control">


                    </div>
                    <div class=" form-group">
                      <label class="control-label"> شماره فرعی
                      </label>
                      <input type="number" v-model="order.product_reference" placeholder="کد " class="form-control">


                    </div>

                    <div class="form-group">
                      <label class="control-label" style="color: #8150e4"> تخفیف {{
                          spliceNumber(order.discount)
                        }} {{ $curency }}
                      </label>
                      <input type="text" v-model="order.discount" class="form-control">

                    </div>

                    <div class="form-group">
                      <label class="control-label"> شرح
                      </label>
                      <input type="text" v-model="order.description" class="form-control">
                    </div>


                  </div>


                  <br>

                  <button v-on:click="updateOrderFields()" data-dismiss="modal" class="btn btn-success">بروزرسانی
                  </button>

                  <button type="button" class="btn btn-default" data-dismiss="modal">بستن</button>
                </div>
              </div>
              <!-- <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

              </div> -->
            </div>


          </div>


          <hr>
          <hr>


          <!-- this row will not appear when printing -->
          <div class="row discunt">
            <br>
            <div class="col-xs-12">

              <!--                    <button type="button" class="btn btn-default " data-toggle="modal" data-target="#myModalsend"-->
              <!--                        style="margin-left: 5px;">{{ $t('Set next reminder') }} </button>-->


              <!--<button v-if="order.state == 0" type="button" v-on:click="paymentCompleted"-->
              <!--data-toggle="modal"-->
              <!--data-target="#payment"-->
              <!--class="btn btn-primary pull-right" style="margin-right: 5px;">-->
              <!--<i class="fa fa-download"></i>  تایید نهایی پرداخت-->
              <!--</button>-->

              <!--<button v-if="order.state == 2" type="button" v-on:click="paymentDone"-->
              <!--<button v-if="order.state != 1 && (order.final_price) <= orderPayments" type="button" v-on:click="paymentDone"-->
<!--              <b-button  size="sm"-->
<!--                         v-if="order.factor_state != 1 && order.state != 3 && (order.final_price) <= orderPayments || contactsPayments >= contactsOrders"-->
<!--                         type="button" v-on:click="paymentDone"-->
<!--                         class="btn btn-success pull-right" style="margin-left: 5px;">-->
<!--                <i class="fa fa-download"></i> {{ $t('Final confirmation of service (receiving points)') }}-->
<!--              </b-button>-->


<!--              <b-button v-if="order.factor_state != 1" size="sm" variant="warning" type="button"-->
<!--                        data-toggle="modal"-->
<!--                        data-target="#loading-inv"-->
<!--                        class="btn btn-warning pull-right" style="margin-right: 5px;">-->
<!--                <i class="fa fa-truck-loading"></i>-->
<!--                ارسال (ورود و خروج)-->
<!--              </b-button>-->


              <!--<a href="invoice-print.html" target="_blank" class="btn btn-default"><i class="fa fa-print"></i> پرینت</a>-->

              <!--<button type="button" v-on:click="pdf" class="btn btn-primary pull-right"-->
              <!--style="margin-right: 5px;">-->
              <!--<i class="fa fa-download"></i> دانلود صورت حساب-->
              <!--</button>-->

              <b-button  v-if="order.factor_state != 1 && $store.state.access" size="sm" variant="primary" type="button"
                         data-toggle="modal"
                         data-target="#payment"
                         class="btn btn-primary pull-right" style="margin-right: 5px;">
                <i class="fa fa-download"></i> {{ $t('pay') }}
              </b-button>


              <b-button size="sm" v-if="order.factor_state != 1 && order.state != 1 && order.state != 3 " type="button" v-on:click="cancelOrder"
                        class="btn btn-danger pull-right" id="cancelBtn" style="margin-right: 5px;">
                <i class="fa fa-download"></i> {{ $t('Cancel order') }}
              </b-button>


              <!--<button type="button" class="btn btn-default" style="float: left"-->
              <!--v-on:click="tableToExcel('printDiv', 'W3C Example Table')">خروجی Excel فاکتور</button>-->


              <b-button size="sm" type="button" v-on:click="print" class="btn btn-secondary float-left mx-2"
                        style="float: left ;margin-left: 5px;"><i class="fa fa-credit-card"></i> {{ $t('print') }}
              </b-button>
              <!--                            <button type="button" v-on:click="printShop" class="btn btn-warning float-left mx-2"-->
              <!--                                    style="float: left ;margin-left: 5px;"><i class="fa fa-credit-card"></i> پرینت رسید-->
              <!--                            </button>-->

              <!--                    <button  v-for="(personItem, personIndex) in personsOrderServices" :key="personIndex"-->
              <!--                             v-if="personItem[0].person != null"-->
              <!--                             type="button" v-on:click="printPerson(personIndex)" class="btn btn-info "-->
              <!--                            style="float: left ;margin-left: 5px;" :title="$t('Print receipt')+' '+personItem[0].person.name +' '+personItem[0].person.family" >-->
              <!--                        {{ $t('receipt') }} {{personItem[0].person.name}} {{personItem[0].person.family}}-->
              <!--                    </button>-->
            </div>


            <!-- Modal -->
            <div id="payment" class="modal fade no-print" role="dialog">
              <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">


                  <form>

                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                      <h4 class="modal-title"> {{ $t('pay') }} </h4>
                    </div>
                    <div class="modal-body">
                      <div class="form-group" v-if="contactsPayments > contactsOrders">
                        <span style="color: #222;">  {{ $t('Extra customer credit') }}    :</span>
                        <span style="font-weight: bold">{{
                            spliceNumber(contactsPayments - contactsOrders)
                          }} {{ $curency }} </span>
                        <br>
                      </div>
                      <div  v-if="$store.state.access" class="form-group">
                        <span style="color: #8150e4;"> {{ $t('The total amount reached') }} :</span>
                        <span style="font-weight: bold">{{ spliceNumber(order.final_price) }} {{ $curency }}</span>
                        <br>
                        <span style="color: #009101;"> {{ $t('Total payments for receipts') }} :</span>
                        <span style="font-weight: bold">{{ spliceNumber(orderPayments) }} {{ $curency }}</span>
                        <br>
                        <span style="color: #ff5444;"> {{ $t('Balance payable') }} :</span>
                        <span style="font-weight: bold">{{
                            spliceNumber(-(contactsPayments - contactsOrders))
                          }} {{ $curency }}</span>


                      </div>


                      <div class="row" v-if="order.payments">


                        <table class="table table-striped  table-bordered  table-sm ">
                          <thead>
                          <tr>
                            <th>ردیف</th>
                            <th>شماره</th>
                            <th>حساب</th>

                            <th>مبلغ</th>
                            <th>تاریخ ثبت</th>
                            <th>وضعیت</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(payment ,paymentIndex) in order.payments"
                              :key="paymentIndex">
                            <td>{{ paymentIndex + 1 }}</td>
                            <td>{{ payment.number + '-' + payment.id }}</td>
                            <td>{{ payment.account }}</td>
                            <td>{{ spliceNumber(payment.amount) }}</td>
                            <td>{{ payment.register_date }}</td>
                            <td>{{ payment.state }}</td>


                          </tr>
                          </tbody>
                        </table>

                      </div>


                      <div class="row"
                           v-if="order.state != 1 && (order.final_price) > orderPayments && contactsPayments < contactsOrders">


                        <div class="col-xs-5 form-group">
                          <label class="control-label">حساب </label>
                          <select v-model="paymentAccount" class="form-control">
                            <option v-for="acc in accounts" :key="acc.id" :value="acc.id">
                              {{ acc.title }} <br/>
                              {{ acc.number }}
                            </option>
                          </select>
                        </div>


                        <div class="col-xs-7  form-group ">
                          <label for=""> {{ $t('The remaining amount is due for payment') }} :
                            {{ spliceNumber(paymentAmount) }} {{ $curency }} </label>
                          <input type="number" min="0" :max="(order.final_price)-orderPayments"
                                 v-model="paymentAmount" class="form-control" placeholder=""
                          >
                        </div>


                      </div>


                    </div>
                    <div class="modal-footer">

                      <button type="button" class="btn btn-default"
                              data-dismiss="modal"> {{ $t('Colse') }}
                      </button>
                      <button  class="btn btn-primary" data-dismiss="modal"
                               v-if="order.state != 1 && (order.final_price) > orderPayments && contactsPayments < contactsOrders"
                               v-on:click="paymentCompleted"> {{ $t('Confirmation of payment of outstanding balance') }}
                      </button>
                    </div>


                  </form>

                </div>

              </div>
            </div>


            <!-- Modal -->
            <div id="loading-inv" class="modal fade no-print" role="dialog">
              <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">


                  <form>

                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                      <h4 class="modal-title">مدیریت ارسال/بارنامه (ورود و خروج انبار) </h4>
                    </div>
                    <div class="modal-body">


                      <div class="row" v-if="order.loadings">


                        <table class="table table-striped  table-bordered  table-sm ">
                          <thead>
                          <tr>
                            <!--                                                        <th>ردیف</th>-->
                            <th>شماره</th>
                            <th>انبار</th>
                            <th>آیتم</th>

                            <th>مقدار/تعداد</th>
                            <th>تاریخ</th>
                            <th>وضعیت</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(loading ,loadingsIndex) in order.loadings"
                              :key="loadingsIndex">
                            <!--                                                        <td>{{loadingsIndex+1}}</td>-->
                            <td>{{ loading.id }}</td>
                            <td>{{ loading.inventory_id }} -
                              <span v-if="loading.inventory_id == 1"> انبار مرکزی  </span>
                              <span v-if="loading.inventory_id == 2"> انبار فروش  </span>
                              <span v-if="loading.inventory_id == 3"> انبار قرنطیه  </span>
                            </td>
                            <!--                                                        <td>{{loading.order_item_id}}</td>-->
                            <td>
                                                          <span v-if="loading.order_item">
                                                              {{ loading.order_item.product.title }}
                                                          </span>
                            </td>

                            <td>{{ spliceNumber(loading.amount) }}</td>

                            <td>
                              {{ loading.loading_date | moment("jYYYY/jMM/jDD") }}
                            </td>
                            <td>{{ loading.state }}</td>

                          </tr>
                          </tbody>
                        </table>


                      </div>


                      <div class="row">


                        <div class="col-xs-5 form-group">
                          <label class="control-label">انبار </label>
                          <select v-model="loadingInv.inventory_id" class="form-control">
                            <option value="">
                              انبار مرکزی - 01
                            </option>
                            <!--                            <option value="2">-->
                            <!--                              انبار فروش - 02-->
                            <!--                            </option>-->
                            <!--                            <option value="3">-->
                            <!--                              انبار قرنطیه - 03-->
                            <!--                            </option>-->
                            <option v-for="inv in inventories" :key="inv.id" :value="inv.id">
                              {{ inv.title }} <br/>
                              {{ inv.number }}
                            </option>
                          </select>
                        </div>

                        <div class="col-xs-5 form-group">
                          <label class="control-label">آیتم </label>
                          <select v-model="loadingInv.order_item_id" class="form-control">
                            <option v-for="order_item in order.order_products" :key="order_item.id"
                                    :value="order_item.id">
                              {{ order_item.product.title }}
                              (<span v-text="filteritemType(order_item.unit)"></span>)

                            </option>
                          </select>
                        </div>

                        <div class="col-xs-7  form-group ">
                          <label for=""> مقدار:
                            {{ spliceNumber(loadingInv.amount) }} </label>
                          <!--                                                  {{order.order_products.find(x => x.id == loadingInv.order_item_id).amount}}-->
                          <input type="number" min="0"
                                 v-model="loadingInv.amount" class="form-control" placeholder=""
                          >
                        </div>


                      </div>


                    </div>
                    <div class="modal-footer">

                      <button type="button" class="btn btn-default"
                              data-dismiss="modal"> {{ $t('Colse') }}
                      </button>
                      <button class="btn btn-primary" data-dismiss="modal"
                              v-on:click="loadingAdd()"> ثبت سند ورود/خروج (بارنامه)
                      </button>
                    </div>


                  </form>

                </div>

              </div>
            </div>


            <div class=" tab-pane" id="remainderPerson">
              <!-- The timeline -->
<!--              <b-button size="sm" type="button" class="btn btn-info btn-xs btn-pulus no-print" data-toggle="modal"-->
<!--                        data-target="#notes">+-->
<!--                افزودن فایل قرارداد / پیوست-->
<!--                &lt;!&ndash;                        {{ $t('Attachment/note') }}&ndash;&gt;-->
<!--              </b-button>-->

              <!-- Modal -->
              <div id="notes" class="modal fade no-print" role="dialog">
                <div class="modal-dialog">

                  <!-- Modal content-->
                  <div class="modal-content">


                    <form v-on:submit.prevent="getAttaches()">

                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title"> افزودن فایل قرارداد / پیوست
                          <!--                                            {{ $t('Attachment/note') }}-->
                        </h4>
                      </div>
                      <div class="modal-body">
                        <div class="form-group">
                          <label for=""> {{ $t('Description') }}</label>
                          <input type="text" v-model="note.comment" class="form-control" name="" id="" placeholder=""
                                 aria-describedby="fileHelpId">
                        </div>
                        <!--<div class="form-group">-->
                        <!--<label for="">امتیاز</label>-->
                        <!--<select v-model="note.rate" class="form-control" name="" id="">-->
                        <!--<option value="1">1</option>-->
                        <!--<option value="2">2</option>-->
                        <!--<option value="3">3</option>-->
                        <!--<option value="4">4</option>-->
                        <!--<option value="5">5</option>-->
                        <!--</select>-->
                        <!--</div>-->

                        <div class="row">
                          <div class="col-xs-12 form-group">
                            <label class="control-label">
                              فایل
                              <!--                                                    {{ $t('Image') }} -->
                            </label>
                            <div class="form-group">
                              <div class="input-group input-file" name="Fichier1">
                                <input type="text" class="form-control" :placeholder="placeholder"/>
                                <input type="file" class="filestyle" ref="file" @change="onFileChangeNote($event)"/>
                                <span class="input-group-btn">
                                            <!--<button class="btn btn-default btn-choose" type="button">فایل</button>-->
                                        </span>
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-default"
                                data-dismiss="modal"> {{ $t('Close') }}
                        </button>
                        <button class="btn btn-primary" data-dismiss="modal" @click="saveAttach"> {{
                            $t('done')
                          }}
                        </button>
                      </div>


                    </form>

                  </div>

                </div>
              </div>


              <br class=" no-print">
              <br class=" no-print">
              <hr class=" no-print">


              <div class="container">
                <div class="row">
                  <!--<div class="col-xs-6 form-group" style="float: right!important;">-->
                  <!--<label class="control-label">نام کالا:-->
                  <!--{{order.id}}-->
                  <!--</label>-->
                  <!--</div>-->

                  <!--<div class="col-xs-6 form-group" >-->
                  <!--<label class="control-label">علت پذیرش:-->
                  <!--{{order.id}}-->
                  <!--</label>-->
                  <!--</div>-->


                </div>


              </div>

              <!--<hr class="no-print">-->

              <!--<div class="col-xs-12 form-group no-print">-->
              <!--<label class="control-label"> طریقه آشنایی:-->
              <!--{{order.introduction}}-->
              <!--</label>-->
              <!--</div>-->


              <hr class=" no-print">


              <div class="col-xs-12">
                {{ order.text }}
              </div>


            </div>


          </div>
        </section>


      </div>


<!--      <div class="col-lg-3 col-md-3 col-sm-12">-->
<!--        &lt;!&ndash; title row &ndash;&gt;-->


<!--        <h6 style="margin-top: -25px"> پیوست ها: </h6>-->


<!--        <b-card class="p-0 m-0" v-for="(note, index) in remainerlist" :key="index">-->

<!--          &lt;!&ndash;<i class="fa fa-envelope bg-blue"></i>&ndash;&gt;-->
<!--          <i class="fa fa-link bg-aqua"></i>-->

<!--          <small class="time">-->
<!--            {{ note.created_at | moment("jYYYY/jMM/jDD") }}-->
<!--          </small>-->
<!--          <div class="timeline-item">-->


<!--&lt;!&ndash;            <h3 v-if="note.person" class="timeline-header">&ndash;&gt;-->
<!--&lt;!&ndash;              {{ note.person.name }} {{ note.person.family }}&ndash;&gt;-->
<!--&lt;!&ndash;            </h3>&ndash;&gt;-->

<!--            <div class="timeline-body">-->
<!--              {{ note.comment }}-->
<!--            </div>-->

<!--            &lt;!&ndash;<div class="timeline-body">امتیاز:&ndash;&gt;-->
<!--            &lt;!&ndash;{{ note.rate }}&ndash;&gt;-->
<!--            &lt;!&ndash;</div>&ndash;&gt;-->


<!--            <div v-if="note.image" class="timeline-body">-->
<!--              <inner-image-zoom v-if="note.image" :src="'/'+note.image" :zoomSrc="'/'+note.image" class="img my-1"-->
<!--                                style="width: 100%"/>-->

<!--              <a class="btn btn-sm btn-info no-print my-1" :href="'/'+note.image" v-if="note.image">-->
<!--                {{ $t('Download') }} </a>-->


<!--            </div>-->
<!--            <div class="timeline-footer  no-print">-->
<!--              <a href="javascript: void(0)" class="btn btn-sm btn-danger"-->
<!--                 v-on:click="deleteAttach(note.id, index)">-->
<!--                {{ $t('Delete') }}-->
<!--              </a>-->

<!--              &lt;!&ndash; <router-link :to="{path: '/payment/'+item.id, params: {id: item.id}}"-->
<!--                  class="btn btn-primary btn-xs">-->
<!--                  رسید سفارش-->
<!--              </router-link> &ndash;&gt;-->


<!--            </div>-->
<!--          </div>-->
<!--        </b-card>-->


<!--      </div>-->

    </div>


    <!--{{ paymentAmount =  contactsOrders-contactsPayments}}-->


    <section class="invoice  fontsforweb_fontid_9189" id="printDiv2" style="display:none">
      <!-- title row -->
      <div class="row ">
        <div class="col-xs-12">
          <h3 class="text-center">
            <i class="fa fa-globe"></i>

          </h3>
        </div>
        <div class="col-xs-12">
          <h4>
            <b> شماره #{{ order.id }}</b>
            <!-- <small class="pull-left">{{order.created_at | moment("dddd, jD jMMMM  jYYYY")}} </small> -->

          </h4>

        </div>
        <!-- /.col -->
      </div>
      <!-- info row -->
      <div class="row invoice-info" style="padding:0 20px">

        <!-- /.col -->

        <!-- /.col -->


        <div class="col-12">
          <span v-if="order.state == 3" class="badge label-success"> {{ $t('Order done') }}</span>
          <span v-if="order.state == 2" class="badge label-info"> {{ $t('Payment approved') }} </span>
          <span v-if="order.state == 1" class="badge label-danger"> {{ $t('Canceled') }} </span>
        </div>
        <div class="col-12"><strong> {{ order.buyer.name }} </strong></div>
        <div class="col-12"><b> تاریخ: </b> {{ order.general_date | moment("dddd, jD jMMMM  jYYYY") }}<br></div>
        <!--                    <div class="col-12">  <b>{{ $t('Visit time') }} :</b> {{ sub(order.general_start)}}<br></div>-->
        <!--                    <div class="col-12"> <b>{{ $t('End time') }} :</b> {{ sub(order.general_end)}}</div>-->
        <div class="col-12"><b> </b> {{ order.title }}<br></div>


        <!-- /.col -->
      </div>
      <!-- /.row -->

      <!-- Table row -->

      <div class="">
        <div class="col-12">
          <table style="    margin: auto;">
            <thead>
            <tr class="table-borderedd">
              <th class="table-borderedd">{{ $t('QTY') }}</th>
              <th class="table-borderedd">{{ $t('services') }}</th>
              <th class="table-borderedd">
                <!--                                    {{$personel}}-->
              </th>


            </tr>
            </thead>
            <tbody v-for="(order_service, index) in order.order_services" :key="index">

            <tr class="table-borderedd">
              <td class="table-borderedd">{{ index + 1 }}</td>
              <td class="table-borderedd"> {{ order_service.service.title }}</td>

              <td class="table-borderedd">
<!--                                    <span v-if="order_service.person !==null">{{ order_service.person.name }}-->
<!--                                        {{ order_service.person.family }}</span>-->
<!--                <span v-else>{{ $t('Unknown') }}</span>-->
              </td>

              <!-- <td>{{order_service.order_id}}-{{order_service.id}}</td> -->
              <!-- {{ order_service }} -->
            </tr>
            <tr class="table-borderedd">
              <!--                                <td  class="table-borderedd">{{ $t('Start') }}  </td>-->
              <!--                                <td  class="table-borderedd">{{ $t('End') }}  </td>-->
              <!-- <td>سریال</td> -->

              <td class="table-borderedd">{{ $t('Price(toman)') }}</td>

            </tr>
            <tr class="table-borderedd">
              <!--                                <td  class="table-borderedd">{{ sub(order_service.start) }}</td>-->
              <!--                                <td  class="table-borderedd"> {{ sub(order_service.end) }}</td>-->

              <td class="table-borderedd">
                <span v-if="$store.state.access">
                                    <span
                                        v-if="!order_service.discount">{{ spliceNumber(order_service.price) }}</span>
                <span v-else>
                                        {{ spliceNumber(order_service.price) - spliceNumber(order_service.discount) }}
                                    </span>
                  </span>
              </td>
            </tr>
            <tr class="table-borderedd-line">
              <th class="table-borderedd" colspan="1">{{ $t('Description of service') }}</th>
              <th class="table-borderedd" colspan="2"> {{ order_service.note }}</th>
            </tr>

            </tbody>


          </table>
          <table class="table-borderedd" v-if="order.items.length !==0">

            <thead>
            <tr class="table-borderedd">
              <th class="table-borderedd">{{ $t('QTY') }}</th>
              <!--<th>تعداد</th>-->
              <th class="table-borderedd">{{ $t('Good') }}</th>
              <!--<th></th>-->
              <!--<th>واحد</th>-->

              <!--<th>مالیات</th>-->

              <th>{{ $t('Price(toman)') }}</th>
              <!--<th>نظر سنجی</th>-->
            </tr>
            </thead>
            <tbody v-for="(item,index) in order.order_products" :key="index">
            <tr>
              <th class="table-borderedd">{{ index + 1 }}</th>
              <!--<td  class="table-borderedd"> {{ item.amount }}</td>-->
              <td class="table-borderedd"> {{ item.product.title }}</td>
              <!--<td> </td>-->
              <!--<td> {{ item.unit }}</td>-->

              <!--<td>{{ item.tax }}</td>-->
              <td class="table-borderedd">
                <span v-if="$store.state.access">
                  {{ spliceNumber(item.price) }} {{ $curency }}
                </span></td>
              <!--<td>-->
              <!--<span v-if="order.order_products.feedback">-->


              <!--<div class="tooltipmain">{{ order.order_products.feedback.comment }}-->
              <!--<span class="tooltiptextmain">-->
              <!--<star-rating :value="order.order_products.feedback.rate"></star-rating>-->
              <!--</span>-->
              <!--</div>-->
              <!--</span>-->
              <!--<span v-else>وجود ندارد</span>-->
              <!--</td>-->
            </tr>

            <!--<tr >-->
            <!--<th colspan="2">شرح</th>-->
            <!--<th colspan="6"> {{item.note}} </th>-->
            <!--</tr>-->
            </tbody>
          </table>
        </div>
        <!-- /.col -->
      </div>

      <!-- /.row -->

      <div class="row">
        <!-- accepted payments column -->
        <div class="col-xs-6">


          <!--<p class="text-muted well well-sm no-shadow" style="margin-top: 10px;">-->
          <!--شرح:-->
          <!--{{ order }}.description}}-->


          <!--</p>-->

          <!--<br>-->


        </div>
        <!-- /.col -->
        <div class="col-xs-6">
          <!-- <p class="lead"> تاریخ: {{order.description | moment("dddd, jD jMMMM  jYYYY")}}</p> -->
          <br>
          <div class="table-responsive maintable">
            <table class="table ">

              <tr v-if="order.discount != ''">
                <th style="width:50%">{{ $t('Total Amount') }}:</th>
                <td>
                  <span  v-if="$store.state.access">
                     {{ spliceNumber(order.final_price + order.general_discount) }} {{ $curency }}
                  </span>
                </td>
              </tr>
              <!--<tr>-->
              <!--<th>مالیات (9.3%)</th>-->
              <!--<td>{{order.general_tax}} </td>-->
              <!--</tr>-->
              <tr v-if="order.discount != ''">
                <th> {{ $t('Discount') }}</th>
                <td>{{ spliceNumber(order.general_discount) }} {{ $curency }}</td>
              </tr>


              <tr v-if="order.discount != ''" style="color: #aa0c5f;">

<!--                <th v-if="order.discount.amount_type == '0'" colspan="2"> {{ order.discount[0].amount }}-->
<!--                  {{ $t('Discount Percentage as') }} "{{ order.discount[0].title }}"-->
<!--                  {{ $t('Subtracted from total amount') }}-->
<!--                </th>-->
<!--                <th v-else colspan="2"> {{ $t('Credit discount with title') }} "{{ order.discount[0].title }}"-->
<!--                  {{ $t('Subtracted from total amount') }}-->
<!--                </th>-->
              </tr>

              <tr>
                <th colspan="2">
                  <hr>
                </th>
              </tr>
              <tr style="font-size: 16px; padding-top: 10px">
                <th style="color: #009101;">{{ $t('Payable amount') }} :</th>
                <td style="font-weight: bold">
                  <span  v-if="$store.state.access">
                    {{ spliceNumber(order.final_price) }} {{ $curency }}
                  </span></td>
              </tr>

            </table>
          </div>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->

      <div class="discunt-shop">
        <button @click="chnagediv" class="discunt-shop btn btn-danger">{{ $t('Back was shown') }}</button>
      </div>


    </section>
    <!-- /.content -->


    <!-- for person print -->

    <section v-for="(personItem, personIndex) in personsOrderServices"

             class="invoice  fontsforweb_fontid_9189 printDiv-persons" :id="'printDiv2-'+personIndex"
             style="display: none">
      <!-- title row -->
      <div class="row ">
        <div class="col-xs-12">
          <h3 class="text-center">
            <i class="fa fa-globe"></i>

          </h3>
        </div>
        <div class="col-xs-12">
          <h4>
            <b> {{ $t('Order number') }} #{{ order.user_id }}{{ order.id }}</b>
            <!-- <small class="pull-left">{{order.created_at | moment("dddd, jD jMMMM  jYYYY")}} </small> -->

          </h4>

        </div>
        <!-- /.col -->
      </div>
      <!-- info row -->
      <div class="row invoice-info" style="padding:0 20px">

        <!-- /.col -->

        <!-- /.col -->


        <div class="col-12">
          <span v-if="order.state == 3" class="badge label-success"> {{ $t('Order done') }}</span>
          <span v-if="order.state == 2" class="badge label-info"> {{ $t('Payment approved') }} </span>
          <span v-if="order.state == 1" class="badge label-danger"> {{ $t('Canceled') }} </span>
        </div>
<!--        <div class="col-12"><strong> {{ order.user.name }} </strong></div>-->
        <div class="col-12"><b> {{ $t('Visit date') }}: </b>
          {{ order.general_date | moment("dddd, jD jMMMM  jYYYY") }}<br></div>
        <div class="col-12"><b>{{ $t('Visit time') }} :</b> {{ sub(order.general_start) }}<br></div>
        <div class="col-12"><b>{{ $t('End time') }} :</b> {{ sub(order.general_end) }}</div>
        <div class="col-12"><b> </b> {{ order.title }}<br></div>


        <!-- /.col -->
      </div>
      <!-- /.row -->

      <!-- Table row -->

      <div class="">
        <div class="col-12">
          <table style="    margin: auto;">
            <thead>
            <tr class="table-borderedd">
              <th class="table-borderedd">{{ $t('QTY') }}</th>
              <th class="table-borderedd">{{ $t('services') }}</th>
              <th class="table-borderedd">{{ $personel }}</th>


            </tr>
            </thead>
            <tbody v-for="(order_service, index) in personItem" :key="index">

            <tr class="table-borderedd">
              <td class="table-borderedd">{{ index + 1 }}</td>
              <td class="table-borderedd"> {{ order_service.service.title }}</td>

              <td class="table-borderedd">
                                    <span v-if="order_service.person !==null">{{ order_service.person.name }}
                                        {{ order_service.person.family }}</span>
                <span v-else>{{ $t('Unknown') }}</span>
              </td>

              <!-- <td>{{order_service.order_id}}-{{order_service.id}}</td> -->
              <!-- {{ order_service }} -->
            </tr>
            <tr class="table-borderedd">
              <td class="table-borderedd">{{ $t('Start') }}</td>
              <td class="table-borderedd">{{ $t('End') }}</td>
              <!-- <td>سریال</td> -->

              <td class="table-borderedd">{{ $t('Price(toman)') }}</td>

            </tr>
            <tr class="table-borderedd">
              <td class="table-borderedd">{{ sub(order_service.start) }}</td>
              <td class="table-borderedd"> {{ sub(order_service.end) }}</td>

              <td class="table-borderedd">
                                    <span
                                        v-if="!order_service.discount">{{ spliceNumber(order_service.price) }}</span>
                <span v-else>
                                        {{ spliceNumber(order_service.price) - spliceNumber(order_service.discount) }}
                                    </span>
              </td>
            </tr>
            <tr class="table-borderedd-line">
              <th class="table-borderedd" colspan="1">{{ $t('Description of service') }}</th>
              <th class="table-borderedd" colspan="2"> {{ order_service.note }}</th>
            </tr>

            </tbody>


          </table>
        </div>
        <!-- /.col -->
      </div>

      <!-- /.row -->

      <div class="row">
        <!-- accepted payments column -->
        <div class="col-xs-6">


        </div>
        <!-- /.col -->
        <div class="col-xs-6">
          <!-- <p class="lead"> تاریخ: {{order.description | moment("dddd, jD jMMMM  jYYYY")}}</p> -->
          <br>
          <div class="table-responsive maintable">
            <table class="table ">

              <tr>
                <th style="width:50%">{{ $t('Total Amount') }}:</th>
                <td>{{ spliceNumber(totalSum(personItem)) }} {{ $curency }}</td>
              </tr>


            </table>
          </div>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->

      <div class="discunt-shop">
        <button @click="chnagedivPerson(personIndex)" class="discunt-shop btn btn-danger">{{
            $t('Back was shown')
          }}
        </button>
      </div>


    </section>


    <div id="myModalsend" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ $t('Record reminder') }} {{ $t('Next for') }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12 form-group">
                <label class="control-label">{{ $t('Title') }} </label>
                <input type="text" v-model="remainder.title" class="form-control">
              </div>
            </div>
            <div class="row" style="display: none">
              <div class="col-xs-12 form-group">
                <label class="control-label">{{ $t('User') }} </label>


                <input type="text" v-model="remainder.contactId" class="form-control">

              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 form-group">
                <label class="control-label"> {{ $t('Context') }}</label>
                <input type="text" v-model="remainder.description" class="form-control">
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 form-group">
                <label class="control-label">{{ $t('Date') }} </label>
                <custom-time-picker v-model="remainder.reminderAt" type="datetime" :clearable="true"
                                    placeholder="تاریخ را انتخاب کنید" min="" max="">
                </custom-time-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="sendRemainder()" data-dismiss="modal"> {{ $t('Send') }}</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('Close') }}</button>
          </div>
        </div>

      </div>
    </div>


    <div id="add-order-product" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h6 class="modal-title">افزودن آیتم کالا به

              <span v-if="order.factor_type == -1">
                رسید خرید
              </span>
              <span v-if="order.factor_type == 2">
                حواله تولید
              </span>
              <span v-if="order.factor_type == -2">
                رسید تولید
              </span>
              <span v-if="order.factor_type == 1">
                حواله/فاکتور {{ $sale }}
              </span>
              <span v-if="order.factor_type == 3">
                صورت وضعیت
              </span>


            </h6>
          </div>
          <div class="modal-body">


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">محصول </label>
                <v-select
                    v-model="productOrder.product_id" class="form-control-sm"
                    :options="products" label="title" :reduce="product => product.id" value="id">
                </v-select>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">کد حسابداری</label>
                <v-select
                    v-model="productOrder.accounting_code_id" class="form-control-sm"
                    :options="accountingCodes" label="title" :reduce="accountingCode => accountingCode.id" value="id">
                </v-select>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">

                <label class="control-label">واحد </label>
                <select class="form-control form-control-sm" v-model="productOrder.unit">
                  <option v-for="(unit,index) in units" :value="unit.id" :key="index">
                    {{ unit.title}}
                  </option>
<!--                  <option value="0"> {{ $t('Number') }}</option>-->
<!--                  <option value="1">{{ $t('g') }}</option>-->
<!--                  <option value="2">{{ $t('Kg') }}</option>-->
<!--                  <option value="3">{{ $t('Liter') }}</option>-->
<!--                  <option value="4">{{ $t('packet') }}</option>-->
                </select>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">

                <label class="control-label">مقدار/تعداد</label>
                <input class="form-control form-control-sm" v-model="productOrder.amount"
                       type="number">
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">قیمت واحد </label>
                <input   v-if="$store.state.access" class="form-control form-control-sm" v-model="productOrder.price"
                       type="number">
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">شرح </label>
                <input class="form-control form-control-sm" v-model="productOrder.note"
                       type="text" data-type="text">
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">مبلغ کل آیتم</label>
                <b   v-if="$store.state.access">{{ spliceNumber(productOrder.price * productOrder.amount) }} {{ $curency }} </b>
              </div>
            </div>


          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="addProductOrder()" data-dismiss="modal"> ثبت آیتم</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('Close') }}</button>
          </div>
        </div>

      </div>
    </div>


    <div id="add-order-service" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h6 class="modal-title">افزودن آیتم خدمات به


              <span v-if="order.factor_type == -1">
                رسید خرید
              </span>
              <span v-if="order.factor_type == 2">
                حواله تولید
              </span>
              <span v-if="order.factor_type == -2">
                رسید تولید
              </span>
              <span v-if="order.factor_type == 1">
                حواله/فاکتور {{ $sale }}
              </span>
              <span v-if="order.factor_type == 3">
                صورت وضعیت
              </span>


            </h6>
          </div>
          <div class="modal-body">


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">آیتم خدمات </label>
                <v-select
                    v-model="serviceOrder.service_id" class="form-control-sm"
                    :options="services" label="title" :reduce="service => service.id" value="id">
                </v-select>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">کد حسابداری</label>
                <v-select
                    v-model="serviceOrder.accounting_code_id" class="form-control-sm"
                    :options="accountingCodes" label="title" :reduce="accountingCode => accountingCode.id" value="id">
                </v-select>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">

                <label class="control-label">تعداد</label>
                <input class="form-control form-control-sm" v-model="serviceOrder.number"
                       type="number">
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">قیمت واحد </label>
                <input   v-if="$store.state.access" class="form-control form-control-sm" v-model="serviceOrder.price"
                       type="number">
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">شرح </label>
                <input class="form-control form-control-sm" v-model="serviceOrder.note"
                       type="text" data-type="text">
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 form-group">
                <label class="control-label">مبلغ کل آیتم</label>
                <b   v-if="$store.state.access">{{ spliceNumber(serviceOrder.price * serviceOrder.number) }} {{ $curency }} </b>
              </div>
            </div>


          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="addServiceOrder()" data-dismiss="modal">ثبت آیتم</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('Close') }}</button>
          </div>
        </div>

      </div>
    </div>


  </div>

</template>

<script>
// document.getElementById("print").addEventListener("click", function() {
// document.on('click',"#print",function(){
//     alert("hi")
// })
// $("#print").click(function() {
//     //  var printContents = document.getElementById('printDiv').innerHTML;
//     //  var originalContents = document.body.innerHTML;
//     //  document.body.innerHTML = printContents;
//     //  window.print();
//     //  document.body.innerHTML = originalContents;
//     alert("hi")
// });

import InnerImageZoom from 'vue-inner-image-zoom';
import OrderInvoice from "./invoice";


const auth = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token')
  }
};


export default {

  components: {
    OrderInvoice,
    'inner-image-zoom': InnerImageZoom
  },
  data() {
    return {

      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token')
        }
      },
      placeholder: "فایل را انتخاب کنید...",

      order: {},
      paymentAccount: '',
      accounts: [],
      discountCode: '',
      reminderItems: '',
      remainder: {},
      loader: false,
      remainerlist: [],
      note: {
        comment: '',
        rate: '0',
        contact_id: '',
        order_id: '',
        image: '',
      },


      contactsOrders: 0,
      contactsPayments: 0,
      orderPayments: 0,

      paymentAmount: 0,

      personsOrderServices: {},


      productOrder: {
        product_id: '',
        unit: '',
        amount: 1,
        note: '',
        price: 0,
        // item: '',
        accounting_code_id: '',
      },

      serviceOrder: {
        service_id: '',
        number: 1,
        note: '',
        price: 0,
        accounting_code_id: '',
      },


      accountingCodes: [],
      products: [],
      services: [],

      projects: [],
      contacts: [],
      units: [],


      inventories: [],


      loadingInv: {
        inventory_id: '',
        order_item_id: '',
        amount: 0
      }

    }
  },

  mounted() {


    // this.$store.state.roles = this.pluck(JSON.parse(localStorage.getItem('roles')), 'name')
    // this.$store.state.accesses = ['superadministrator', 'admin']
    // this.$store.commit('intersection')
    // this.$store.commit('checkIntersection')

    this.updateOrder()

    // this.getAttaches()

    // this.getAccounts()

    // this.getPersonsOrderServices()


    // this.getAccountingCodes()
    // this.getProducts()
    // this.getServices()


    // this.getUnits();
    // this.getProjects();
    // this.getContacts();

  },


  methods: {

    sub(str) {
      if (str != null) {
        return str.substring(0, 5)
      }

    },

    pluck(array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },

    totalSum(items) {

      var total = 0;

      this.pluck(items, 'price').forEach(function (element) {
        console.log(element)

        total = Number(total) + Number(element)

      });

      return total;
    },

    updateOrder() {

      let app = this;
      let id = app.$route.params.id;
      //          this.order = app.$route.params.order;
      app.itemId = id;
      axios
          .get('v2/api/factor-service/factors?companyId='+this.$companyId+'&fromDate=&toDate=&codeFrom=&codeTo=&factorId=' + id, app.auth)
          .then(function (resp) {
            app.order = resp.data[0];


            console.log(resp.data[0], "44")



          })
          .catch(function () {
            app.$snotify.error(app.$t('Request information is not available'));
            app.$router.push({
              path: '/order/list'
            });
            //                  alert("بارگذاری دسته بندی ها امکان پذیر نیست");
            //                    console.log('a: ' + auth)
          });


    },

    isActive() {

      if (this.order.state > 0)
        return true
      else
        return false


    },

    canceled() {

      if (this.order.state == 1)
        return "opacity: 0.2"

    },

    spliceNumber(number) {
      //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

      $("input[data-type='number']").keyup(function (event) {
        var $this = $(this);
        var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
        $this.val(num2);
      });
      if (number && number != '') {
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      }

    },

    applyDiscountToOrder() {

      var app = this;
      var newItem = {
        code: app.discountCode,
        order_id: app.itemId,
      };
      axios.post('/api/orders/discount', newItem, app.auth)

          .then(function (resp) {
            console.log(resp.data.data);
            app.$snotify.success(app.$t('Discount code applied successfully'));
            // location.reload(true)
            app.updateOrder();
            //                        this.$forceUpdate();
          })
          .catch(function (e) {

            if (e.response.data.message != 'The given data was invalid.') {
              app.$snotify.warning(e.response.data.message);

            }
            //                                                     app.$snotify.warning('کد تخفیف در سیستم یافت نشد');
            for (const error of e.response.data.messages_fa) {
              app.$snotify.warning(error);
            }


            console.log(e.response);


            //                        app.errors.push(e.response.data.messages);
            //                        console.log(Object.entries(app.errors));
            //                        for (let value of Object.entries(app.errors[0])) {
            //                            app.$snotify.warning(value[1], {
            //                                timeout: 7000,
            //                                closeOnClick: true,
            //                                pauseOnHover: true
            //                            });
            //                        }

          });

    },

    paymentCompleted() {
      var app = this;
      var newItem = {
        order_id: app.itemId,
        pay_state: 2,
        amount: app.paymentAmount,
        account: app.paymentAccount,

      };

      if (app.paymentAmount > (app.order.final_price) - (app.orderPayments)) {
        app.$snotify.warning(app.$t('The selected amount is greater than the remaining factor of the invoice'));
        return false
      }


      axios.post('/api/orders/payed', newItem, app.auth)

          .then(function (resp) {
            console.log(resp.data.data);
            // document.getElementById("proccess").querySelectorAll("li").forEach(function (el) {
            //     console.log(el.classList.remove("is-active"))
            // })
            app.$snotify.success(app.$t('Payment confirmed successfully'));
            app.updateOrder();
          })
          .catch(function (e) {


            app.$snotify.warning(e.response.data.message);

            console.log(e.response.data.message);


            //                        for (const error of e.response.data.messages_fa) {
            //                            app.$snotify.warning(error);
            //                        }

          });
    },

    cancelOrder() {
      var app = this;
      var newItem = {
        order_id: app.itemId,
      };

      if (confirm(app.$t('Are you sure you want to cancel the order?'))) {

        axios.post('/api/orders/cancel', newItem, app.auth)

            .then(function (resp) {
              // console.log(resp.data.data);
              document.getElementById("proccess").style.opacity = "0.5";
              document.getElementById("cancelBtn").style.display = "none";
              //                        location.reload(true)
              app.$snotify.success(app.$t('Order canceled'));
              app.updateOrder();


            })
            .catch(function (e) {


              app.$snotify.warning(e.response.data.message);

              console.log(e.response.data.message);


              //                         for (const error of e.response.data.messages_fa) {
              //                            app.$snotify.warning(error);
              //                        }

            });

      }
    },

    paymentDone() {
      var app = this;
      var newItem = {
        order_id: app.itemId,
        //                    pay_state: 3

      };

      if (confirm(app.$t('Are you sure you have a final order confirmation?'))) {


        axios.post('/api/orders/completed', newItem, app.auth)

            .then(function (resp) {
              console.log(resp.data.data);
              // document.getElementById("proccess").querySelectorAll("li").forEach(function (el) {
              //     console.log(el.classList.remove("is-active"))
              // })
              app.$snotify.success(app.$t('The service was successfully approved'));
              app.updateOrder();
            })
            .catch(function (e) {


              app.$snotify.warning(e.response.data.message);

              console.log(e.response.data.message);

            });

      }
    },

    getAccounts() {

      axios
          .get('/api/payment/Account', this.auth)
          .then(response => {
            this.accounts = response.data.data;
            console.log(this.items);

          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
          .finally(() => this.loading = false)
    },

    print() {
      // var printContents = document.getElementById('printDiv').innerHTML;
      window.print();
    },

    chnagediv() {
      document.getElementById("printDiv").style.display = "block"
      document.getElementById("printDiv2").style.display = "none"
    },

    chnagedivPerson(personIndex) {
      document.getElementById("printDiv").style.display = "block"
      document.getElementById("printDiv2").style.display = "none"
      document.getElementById("printDiv2-" + personIndex).style.display = "none"
    },

    printShop() {
      document.getElementById("printDiv").style.display = "none"
      document.getElementById("printDiv2").style.display = "block"
      window.print();
//                    var mywindow = window.open('', 'PRINT', 'height=800,width=800');

//                     mywindow.document.write('<html><head><title>' + document.title  + '</title>');
//                     //  mywindow.document.writeln('<html><head/><body><img id="myImage" src="https://www.google.pl/images/srpr/logo11w.png" alt="logo"/></body></html>');
//                     mywindow.document.write(`</head>
//                     <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">
//         <style>
//  @font-face {
// 	font-family: 'bnazanb';
// 	src: url('../fonts/bnazanb.eot');
// 	src: local('bnazanb'), url('../fonts/bnazanb.woff') format('woff'), url('../fonts/bnazanb.ttf') format('truetype');
// }
// .fontsforweb_fontid_9189 {
// 	font-family: 'bnazanb' !important;
// }
// </style>
//                     <body dir="rtl">`);
//                     //   mywindow.document.write('<link rel="stylesheet" href="/file/FontAwesome.css" type="text/css" />');
//                     mywindow.document.write(`<h4 style="text-align:center">` + document.title  + `</h4>`);

//                     mywindow.document.write(``);
//                     mywindow.document.writeln(document.getElementById("printDiv2").innerHTML);


//                     mywindow.document.write('</body></html>');

//                       mywindow.document.close(); // necessary for IE >= 10
//                       mywindow.focus(); // necessary for IE >= 10*/

//                      mywindow.print();
//                       mywindow.close();
//                     console.log(mywindow.document)
//                     return true;
    },

    printPerson(personIndex) {

      document.getElementById("printDiv").style.display = "none"
      document.getElementById("printDiv2-" + personIndex).style.display = "block"
      window.print();

    },

    pdf() {
      let pdfName = 'test';
      var doc = new jsPDF();
      doc.text("مهدی", 10, 10);
      // doc.autoPrint({variant: 'non-conform'});
      doc.save(pdfName + '.pdf');

    },

    sendRemainder() {
      var app = this


      app.remainder.contactId = app.order.contact.id

      app.remainder.reminderAt = app.remainder.reminderAt + ":00"
      app.remainder.executeAt = app.remainder.reminderAt
      console.log(app.remainder)
      axios.post(`/api/reminder/sendRemember`, app.remainder, app.auth)
          .then(response => {
            app.$snotify.success(app.$t('Next reminder set successfully'));

            console.log(response)
            //                        app.remainder={}
            //                         console.log(e)
            //                         console.log(this.items)
            // console.log("sss", this.services)

          })
          .catch(error => {
            console.log(error);
            app.errored = true
          })
          .finally(() => app.loading = false);
    },

    tableToExcel(table, name) {

      var uri = 'data:application/vnd.ms-excel;base64,',
          template =
              '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
          base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)))
          },
          format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
              return c[p];
            })
          }


      if (!table.nodeType) table = document.getElementById(table)
      var ctx = {
        worksheet: name || 'Worksheet',
        table: table.innerHTML
      }
      window.location.href = uri + base64(format(template, ctx))

    },

    onFileChangeNote(e) {

      //    console.log(e.target.files[0])
      this.note.image = this.$refs.file.files[0];
      this.placeholder = this.$refs.file.files[0].name
      console.log(this.note.image, "note ch 144")

    },

    getAttaches() {


      let app = this


      let contact_id = 0
      let contact_order_id = app.$route.params.id

      axios
          .get(`/api/contactOrder/${contact_id}/${contact_order_id}/reviews`, app.auth)
          .then(function (resp) {
            console.log(resp.data, "remainerlist")
            app.remainerlist = resp.data.data;

          })
          .catch(function () {
            // app.$snotify.error('اطلاعات  در دسترس نیست');

          });

    },

    deleteAttach(id, index) {
      if (confirm("از حذف آیتم مطمئن هستید؟")) {
        var app = this;
        axios.delete(`/api/contactOrder/${app.order.contact.id}/${app.order.id}/reviews/` + id, app.auth)
            .then(function (resp) {
              app.remainerlist.splice(index, 1);
            })
            .catch(function (resp) {
              // alert("امکان حذف آیتم وجود ندارد");
            });
      }
    },

    saveAttach() {

      var app = this;
      var newItem = app.note;

      if (app.note.comment == '') {
        app.$snotify.warning('متنی برای پیوست وارد کنید');
        return false

      }
      newItem.contact_id = app.order.contact.id
      newItem.order_id = app.order.id


      let formData = new FormData();
      for (const key in newItem) {
        if (newItem.hasOwnProperty(key)) {
          const element = newItem[key];
          formData.append(key, element)
          console.log(key, element);
        }
      }

      axios
          .post(`/api/contactOrder/${newItem.contact_id}/${newItem.order_id}/reviews`, formData, app.auth)
          //                axios.post('/api/services', formData, app.auth)
          .then(function (resp) {
            app.$snotify.success(app.$t('Item saved successfully'));

            app.getAttaches()

//                        console.log(formData);
            console.log(resp);

          })
          .catch(function (e) {
            app.$snotify.warning('خطا در ثبت پیوست');
            console.log(e.response.data);


            for (let value of e.response.data.messages_fa) {
              //                        for (let error of Object.entries(value[1])) {
              //                            console.log(app.object.entries(app.errors[0]));

              app.$snotify.warning(value, {
                timeout: 7000,
                //                                    showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
              });

              //                        }
            }

          });
    },

    getContactsOrders() {

      let app = this;

      axios
          .get('/api/contact/orders/' + app.order.contact.id, app.auth)
          .then(function (resp) {
            app.contactsOrders = resp.data;

            app.getContactsPayments()

          })
          .catch(function () {
            app.$snotify.error(app.$t('No information available'));
            app.$router.push({
              path: '/contacts/'
            });
          });
    },

    getContactsPayments() {

      let app = this;
      axios
          .get('/api/contact/payments/' + app.order.contact.id, app.auth)
          .then(function (resp) {
            app.contactsPayments = resp.data;

            app.getOrderPayments()


          })
          .catch(function () {
            app.$snotify.error(app.$t('No information available'));
            app.$router.push({
              path: '/contacts/'
            });
          });
    },

    getOrderPayments() {

      let app = this;
      axios
          .get('v2/api/factor-service/factors?companyId='+this.$companyId+'&fromDate=2024-01-03&toDate=2025-02-03&codeFrom=&codeTo=&factorId=' + app.order.id, app.auth)
          .then(function (resp) {
            app.orderPayments = resp.data;

            app.paymentAmount = app.contactsOrders - app.contactsPayments

            //// not ok -- for test

            // app.paymentAmount > (app.order.final_price)-(app.orderPayments)

//                        if(app.contactsPayments >= app.contactsOrders){
            if (app.contactsOrders - app.contactsPayments > (app.order.final_price) - (app.orderPayments))
              app.paymentAmount = app.order.final_price - app.orderPayments

//                            app.paymentAmount = app.contactsOrders-app.contactsPayments
//                        }else{
//                            app.paymentAmount =  app.order.final_price-app.orderPayments
//                        }


          })
          .catch(function () {
            app.$snotify.error(app.$t('No information available'));
            app.$router.push({
              path: '/contacts/'
            });
          });
    },

    alert() {
      alert('دسترسی به این امکان محدود شده است')
    },

    updateServiceItem(order_service) {


      var app = this;

      var services = [];
      services.push(order_service)

      var newItem = {
        services: services

      };


      console.log('imp12')
      console.log(newItem)

      axios
          .post(`/api/updateOrder/updateServiceItem/${app.order.id}`, newItem, app.auth)
          //                axios.post('/api/services', formData, app.auth)
          .then(function (resp) {
            app.$snotify.success(app.$t('Item saved successfully'));


            app.updateOrder()
//                        this.getAttaches()
//                        this.getAccounts()


            console.log(resp);

          })
          .catch(function (e) {
            console.log(e.response.data);

            for (let value of e.response.data.messages_fa) {

              app.$snotify.warning(value, {
                timeout: 7000,
                closeOnClick: true,
                pauseOnHover: true
              });

            }

          });

    },

    updateProductItem(order_product) {

      var app = this;

      var products = [];
      products.push(order_product)

      var newItem = {
        products: products

      };


      console.log('imp12')
      console.log(newItem)

      axios
          .post(`/api/updateOrder/updateProductItem/${app.order.id}`, newItem, app.auth)
          //                axios.post('/api/services', formData, app.auth)
          .then(function (resp) {
            app.$snotify.success(app.$t('Item saved successfully'));


            app.updateOrder()
//                        this.getAttaches()
//                        this.getAccounts()


            console.log(resp);

          })
          .catch(function (e) {
            console.log(e.response.data);

            for (let value of e.response.data.messages_fa) {

              app.$snotify.warning(value, {
                timeout: 7000,
                closeOnClick: true,
                pauseOnHover: true
              });

            }

          });

    },

    updateOrderFields() {
      var app = this;
      var newItem = app.order


      axios
          .post(`/api/updateOrder/updateOrderFields/${app.order.id}`, newItem, app.auth)
          //                axios.post('/api/services', formData, app.auth)
          .then(function (resp) {
            app.$snotify.success(app.$t('Item saved successfully'));


            app.updateOrder()
//                        this.getAttaches()
//                        this.getAccounts()


            console.log(resp);

          })
          .catch(function (e) {
            console.log(e.response.data);

            for (let value of e.response.data.messages_fa) {

              app.$snotify.warning(value, {
                timeout: 7000,
                closeOnClick: true,
                pauseOnHover: true
              });

            }

          });

    },

    stateColor(index) {
      switch (index) {

        case '0':
          return "badge-info"
          break;
        case '1':
          return 'badge-danger'
          break;
        case '2':
          return 'badge-success'
          break;
        case '3':
          return "badge-primary"
          break;
        default:
          break;
      }
    },

    stateorder(index) {
      switch (index) {

        case '0':
          return 'ثبت اولیه'
          break;
        case '1':
          return 'برگشت خورده'
          break;
        case '2':
          return 'پرداخت شده'
          break;
        case '3':
          return 'ثبت نهایی سند'
          break;
        default:
          break;
      }
    },

    getPersonsOrderServices() {

      let app = this;
      let id = app.$route.params.id;
      app.itemId = id;
      axios
          .get('/api/orderPayment/personsOrderServices/' + id, app.auth)
          .then(function (resp) {

            app.personsOrderServices = resp.data;

          })
          .catch(function () {
            app.$snotify.error(app.$t('Request information is not available'));

          });
    },

    filteritemType(item) {

      var unit = null
      if(unit = this.units.find(x => x.id == item))
        return unit.title
      else return 'نامشخص'

      // switch (item) {
      //     case '0':
      //         return  this.$t('Number')
      //         break;
      //     case '1':
      //         return  this.$t('g')
      //         break;
      //     case '2':
      //         return  this.$t('Kg')
      //         break;
      //     case '3':
      //         return   this.$t('Liter')
      //         break;
      //     case '4':
      //         return  this.$t('packet')
      //         break;
      //     default:
      //         return  this.$t('Unknown')
      // }
    },

    addProductOrder() {

      var app = this;
      var newItem = {
        products: []
      };
      newItem.products.push(app.productOrder)


      axios.post('/api/updateOrder/addProductItem/' + app.order.id, newItem, app.auth)
          .then(function (resp) {
            app.$snotify.success('ثبت با موفقیت انجام شد');

            app.updateOrder()

            app.productOrder.product_id = ''
            app.productOrder.unit = ''
            app.productOrder.amount = 0
            app.productOrder.note = ''
            app.productOrder.price = 0
            // app.productOrder.item= ''
            app.productOrder.accounting_code_id = ''

          })
          .catch(function (e) {

            app.$snotify.warning('ورودی ها را چک کنید');
            // app.$snotify.warning(e.response.data.message);
            console.log(e.response.data.message);

          });

    },

    addServiceOrder() {

      var app = this;
      var newItem = {
        services: []
      };
      newItem.services.push(app.serviceOrder)

      axios.post('/api/updateOrder/addServiceItem/' + app.order.id, newItem, app.auth)
          .then(function (resp) {
            app.$snotify.success('ثبت با موفقیت انجام شد');

            app.updateOrder()

            app.serviceOrder.product_id = ''
            app.serviceOrder.number = 0
            app.serviceOrder.note = ''
            app.serviceOrder.price = 0
            app.serviceOrder.accounting_code_id = ''
          })
          .catch(function (e) {
            app.$snotify.warning('ورودی ها را چک کنید');
            // app.$snotify.warning(e.response.data.message);
            console.log(e.response.data.message);

          });

    },

    deleteProductOrder(itemId) {
      if (confirm(this.$t('Are you sure you want to delete the item?'))) {
        var app = this;
        axios.get('/api/updateOrder/deleteProductItem/' + itemId, app.auth)
            .then(function (resp) {
              app.$snotify.success('حذف با موفقیت انجام شد');
              app.updateOrder()

            })
            .catch(function (e) {
              app.$snotify.warning(e.response.data.message);
              console.log(e.response.data.message);
            });
      }
    },

    deleteServiceOrder(itemId) {
      if (confirm(this.$t('Are you sure you want to delete the item?'))) {
        var app = this;
        axios.get('/api/updateOrder/deleteServiceItem/' + itemId, app.auth)
            .then(function (resp) {
              app.$snotify.success('حذف با موفقیت انجام شد');
              app.updateOrder()
            })
            .catch(function (e) {
              app.$snotify.warning(e.response.data.message);
              console.log(e.response.data.message);
            });
      }
    },

    getAccountingCodes() {
      axios.get('/api/accountingCodesList', this.auth)
          .then(response => {
            this.accountingCodes = response.data.data;

          })
          .catch(error => {
            console.log(error);
          })
    },

    getProducts() {
      axios
          .get('/api/productslist', this.auth)
          .then(response => {
            this.products = response.data.data;
            this.products.forEach(function (element) {
              element.number = "1";
            });
          })
          .catch(error => {
            console.log(error);
          })
    },

    getServices() {

      axios
          .get('/api/order/getAvailableServices?date=' + this.order.date, this.auth)
          .then(response => {
            var result = Object.keys(response.data.data).map(function (key) {
              return response.data.data[key];
            });
            this.services = result;

            this.services.forEach(function (element) {
              element.number = "1";
            });

          })
          .catch(error => {
            console.log(error);
          })
    },
    getUnits() {
      axios
          .get('/api/unitList', this.auth)
          .then(response => {

            this.units = response.data;
          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
    },

    getProjects() {
      axios
          .get('/api/projectList', this.auth)
          .then(response => {
            this.projects = response.data;
          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
    },

    getContacts(){

      axios.get('/api/contactslist', this.auth)
          .then(response => {
            this.contacts = response.data;
          })
          .catch(error => {
            // this.loader = false
            console.log(error);
          })
    },

    makeContactOptions() {
      var app = this;
      for (const key in app.contacts) {
        if (app.contacts.hasOwnProperty(key)) {
          const element = app.contacts[key];

          app.contactOptions.push({
            value: element.id,
            text: element.first_name + ' ' + element.last_name
          })
        }
      }
      console.log(app.contacts)
      console.log(app.contactOptions)
    },


    loadingAdd() {
      var app = this;

      var newItem = {

        inventory_id: app.loadingInv.inventory_id,
        amount: app.loadingInv.amount,
        order_item_id: app.loadingInv.order_item_id,
        order_item_type: 'APP/Product',
        order_id: app.itemId,
        state: 0,


      };

      axios.post('/api/orders/addLoading', newItem, app.auth)

          .then(function (resp) {
            console.log('addLoading', resp.data.data)

            app.$snotify.success('سند با موفقیت ثبت شد')
            app.updateOrder();
          })
          .catch(function (e) {
            app.$snotify.warning(e.response.data.message);
            console.log(e.response.data.message);
          });
    },


  }

}
//     var doc = new jsPDF();
// var specialElementHandlers = {
//     '#editor': function (element, renderer) {
//         return true;
//     }
// };
// $('#submit').click(function () {
//     doc.fromHTML($('#content').html(), 15, 15, {
//         'width': 190,
//             'elementHandlers': specialElementHandlers
//     });
//     doc.save('sample-page.pdf');
// });


//   $('.translate').text(function (i, v) {
//         var chars = v.split('');
//         for (var i = 0; i < chars.length; i++) {
//             if (/\d/.test(chars[i])) {
//                 chars[i] = arabicNumbers[chars[i]];
//             }
//         }
//         return chars.join('');
//     })

</script>
<style>

small {
  color: #7e7e7e;
}


/* Tooltip container */
.tooltipmain {
  position: relative;
  display: inline-block;
  /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltipmain .tooltiptextmain {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltipmain .tooltiptextmain::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltipmain:hover .tooltiptextmain {
  visibility: visible;
  opacity: 1;
}

/* @page {
    size: 5.5in 8.5in;
}
*/
@media print {

  body,
  .discunt,
  .discunt-shop * {
    visibility: hidden !important;
  }

  #printDiv, #printDiv2 * {
    visibility: visible;
  }

  .printDiv-persons * {
    visibility: visible;
  }


}

.maintable {
  border: 0px !important
}

.text-center {
  text-align: center
}

.lkbLoggo {
  width: 9.182cm !important;
  height: 2.721cm !important;
  margin-top: 0.199cm !important;
  background-image: url("/dist/img/user2-160x160.jpg") !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}


.table-borderedd {
  border: 1px solid #000;
  padding: 2px 7px
}

.table-borderedd-line {
  border-top: 1px solid #000;
  border-bottom: 5px solid gray;
  margin-bottom: 2px;
}
</style>
